'use strict'

import { axiosGet } from '../../../axios/axios.js'

export default class ReportMaterialsGroup {
  constructor (config) {
    this.key = config.key
    this.name = config.name
    this.consumingType = config.consumingType
    this.report = config.report // TODO не реактивное
    this.reportId = config.report.id

    this.records = []
    this.initialRecords = []

    this.savedRecordsString = '[]' // TODO не реактивное
    // this.recordsFromOtherDepartures = null
  }

  get records () {
    return this.report[this.key]
  }

  set records (records) {
    this.report[this.key] = records
  }

  get recordsFromOtherDepartures () {
    return this.report[this.key + 'FromOtherDepartures']
  }

  set recordsFromOtherDepartures (records) {
    this.report[this.key + 'FromOtherDepartures'] = records
  }

  // load ===

  loadRecords () {
    const groupKey = this.key

    return axiosGet({
      url: '/service/delta/report/' + this.reportId + '/' + groupKey,
      onSuccess: (response) => {
        const data = response.data
        this.setLoadedData(data)
        return data
      },
      onFailure: this.name + ': ошибка получения записей',
      throws: true
    })
  }

  // protected
  setLoadedData (data) {
    this.setLoadedRecords(data.result)
    this.recordsFromOtherDepartures = [...(data.otherResults || []), ...data.result]
  }

  // protected
  setLoadedRecords (records) {
    const initialRecords = []
    for (const record of records) {
      record.isChecked = false
      record.hasLoops = !!record.hasLoops

      const initialRecord = JSON.parse(JSON.stringify(record))
      initialRecords.push(initialRecord)
      Object.defineProperty(record, '_initial', {
        value: initialRecord,
        writable: false,
        enumerable: false,
        configurable: true
      })
      // Object.defineProperty(initialRecord, '_current', {
      //   value: record,
      //   writable: false,
      //   enumerable: false,
      //   configurable: true
      // })
    }
    this.records = records
    this.initialRecords = initialRecords
    this.savedRecordsString = JSON.stringify(records)
  }

  // ===

  hasChanges () {
    return JSON.stringify(this.records) !== this.savedRecordsString
  }

  applyChanges (properties) {
    const recordsChanges = this.getRecordsChanges()
    if (recordsChanges.recordsToSave.length) {
      properties[this.key + 'Properties'] = recordsChanges.recordsToSave
    }
    if (recordsChanges.recordsToRemove.length) {
      properties[this.key + 'RemoveProperties'] = recordsChanges.recordsToRemove
    }
  }

  getRecordsChanges () {
    const records = this.records
    const recordsToSave = []
    for (const record of records) {
      if (!record._initial || this.isRecordChanged(record._initial, record)) { // новые или измененные записи
        recordsToSave.push(record)
      }
    }

    const recordsToRemove = []
    for (const initialRecord of this.initialRecords) {
      // if (!records.includes(initialRecord._current)) {
      const updatedRecord = records.find(record => this.hasEqualComplexKeys(record, initialRecord))
      if (updatedRecord == null) {
        recordsToRemove.push(initialRecord)
      }
      // }
    }

    return { recordsToSave, recordsToRemove }
  }

  // protected
  isRecordChanged (initial, record) {
    for (const key of Object.keys(record)) {
      if (JSON.stringify(initial[key]) !== JSON.stringify(record[key])) {
        return true
      }
    }
    return false
  }

  // protected
  hasEqualComplexKeys (record1, record2) {
    if (record1.recId !== record2.recId) {
      return false
    }
    return true
  }

  // Замечания

  get allRemarks () {
    const remarks = this.commonRemarks
    for (const record of this.records) {
      if (record.noted == 'hasNotes') {
        remarks.push({
          reportName: this.report.name,
          name: record.toolName,
          // toolName: record.toolName,
          // noted: record.noted,
          get comment () {
            return record.note
          },
          set comment (value) {
            record.note = value
          },
          get done () {
            return record.noteDone
          },
          set done (value) {
            record.noteDone = value
          },
          get important () {
            return record.important
          },
          set important (value) {
            record.important = value
          }
        })
      }
    }
    if (!remarks.length) {
      remarks.push({
        reportName: this.report.name
      })
    }
    return remarks
  }

  get commonRemarks () {
    const remarksProperty = this.consumingType + 'Remarks'
    const commonRemarks = this.report[remarksProperty]
    const reportName = this.report.name

    const remarks = []
    if (commonRemarks && commonRemarks.length) {
      commonRemarks.forEach((commonRemark) => {
        if (commonRemark.active === true) {
          remarks.push({
            reportName,
            name: 'Общее замечание',
            // toolName: 'Общее замечание',
            get comment () {
              return commonRemark.comment
            },
            set comment (value) {
              commonRemark.comment = value
            },
            get done () {
              return commonRemark.done
            },
            set done (value) {
              commonRemark.done = value
            },
            get important () {
              return commonRemark.important
            },
            set important (value) {
              commonRemark.important = value
            }
          })
        }
      })
    }
    return remarks
  }
}
